import { lhcUrl, lhcDepartmentPrefix } from "../_constants/user.constants";
import { userService } from "../_services/user.service";
import { getLang } from "./language";
import { history } from "./history";
import "../css/lhcWidget.css";

// Наши коды языков → варианты сайта LHC (ключи available_site_access в его settings.ini).
// Английского здесь нет намеренно: в LHC он язык по умолчанию, и штатный код встраивания
// параметр lang для него не ставит.
const LHC_LANGS = { ru: "rus", cn: "chn" };

// Без отдела LHC отдаёт чат в общий отдел NaviConf.
const GENERAL = [];

// Параметры виджета — то, что LHC ждёт в window.LHC_API.args. Размеры взяты из кода
// встраивания, который генерирует сама админка LHC.
export const lhcArgs = (baseUrl, lang, department = GENERAL) => {
  const args = {
    mode: "widget",
    lhc_base_url: `${baseUrl}/index.php/`,
    wheight: 450,
    wwidth: 350,
    pheight: 520,
    pwidth: 500,
    leaveamessage: true,
  };

  if (LHC_LANGS[lang]) args.lang = `${LHC_LANGS[lang]}/`;
  if (department.length) args.department = department;

  return args;
};

// Страницы конференции для посетителя: публичная и она же в его кабинете. Привязанный
// домен сюда же — ConfListPage переводит его корень на /event/{id}. «Вид для клиента»
// (/client_view) не в счёт: организатору свой отдел ни к чему, ему нужны мы.
export const conferenceIdFromPath = (pathname) => {
  const match = /^\/(?:event|conf_view)\/(\d+)\/?$/.exec(pathname || "");
  return match ? match[1] : null;
};

// Отдел чата на странице конференции; null — чата нет совсем. Отдел в LHC бэк заводит
// только опубликованной конференции с «Онлайн-поддержкой», под меткой <префикс>-<id>.
// Метку без отдела LHC молча уводит в общий отдел, поэтому условия — те же, что у бэка.
// Выключенная поддержка — без чата: иначе вопросы о чужой конференции пойдут нам.
// Неопубликованную смотрит в основном сам организатор — ему общий чат.
export const conferenceChat = (conf, prefix) => {
  if (!conf || !prefix) return GENERAL;
  if (conf.is_published !== "published") return GENERAL;
  if (Number(conf.online_support) !== 1) return null;
  return [`${prefix}-${conf.id}`];
};

const sameDepartment = (a, b) => a.join(",") === b.join(",");

// Токен кабинета для ИИ-агента. В LHC это скрытая от оператора переменная чата
// user_token (Additional chat variables, значение lhc_var.user_token), бот
// подставляет её в запрос к агенту. Идентификатор без префикса «lhc.»: с ним LHC пишет
// значение в одноимённое поле самого чата (как lhc.email), и в переменные оно не попадает.
const lhcVar = {};

const setArgs = (department) => {
  window.LHC_API.args = { ...lhcArgs(lhcUrl, getLang(), department), lhc_var: lhcVar };
  // Тот же объект — и глобальным lhc_var: из args скрипт LHC только следит за записями,
  // а значения в iframe виджета, с которыми стартует чат, берёт по пути lhc_var.user_token
  // от window (wrapper/src/util/chatEventsHandler.js, getJSVarsValues). Без этого чат
  // уходит без токена, пока тот не сменится уже после загрузки страницы.
  window.lhc_var = lhcVar;
};

// Вход и выход меняют токен без перезагрузки страницы, но всегда с переходом по history.
// Скрипт LHC при загрузке заворачивает lhc_var в Proxy и на каждую запись сам отправляет
// переменные в идущий чат (chat/updatejsvars). Пустую строку он не шлёт, и LHC переменную
// стирает — после выхода токена в чате не остаётся. Сверено по исходникам LHC 4.93
// (design/defaulttheme/widget/wrapper/src/util/userSession.js).
export const syncUserToken = () => {
  const token = localStorage.getItem("token") || "";
  const lhc = window.$_LHC;
  const vars = (lhc && lhc.attributes && lhc.attributes.lhc_var) || lhcVar;
  // Без проверки каждый переход по сайту слал бы запрос в LHC.
  if (vars.user_token !== token) vars.user_token = token;
};

let scriptAdded = false;
let current = GENERAL;
let pathSeq = 0;
const conferenceCache = {};

const loadScript = () => {
  scriptAdded = true;

  const script = document.createElement("script");
  const now = new Date();

  // Дата в адресе — как в штатном коде встраивания: скрипт кэшируется не дольше суток,
  // и обновление LHC на сервере доезжает до посетителей без пересборки фронта.
  script.src = `${lhcUrl}/design/defaulttheme/js/widgetv2/index.js?${now.getFullYear()}${now.getMonth()}${now.getDate()}`;
  script.async = true;
  script.setAttribute("crossorigin", "anonymous");
  document.head.appendChild(script);
};

const applyDepartment = (department) => {
  // Спрятать (src/css/lhcWidget.css), а не снести: виджет LHC убирать со страницы не умеет.
  document.body.classList.toggle("naviconf-lhc-off", department === null);
  if (department === null) return;

  if (!scriptAdded) {
    setArgs(department);
    current = department;
    loadScript();
    return;
  }

  if (sameDepartment(current, department)) return;
  current = department;

  // Скрипт LHC читает LHC_API.args один раз, при исполнении. Уже исполнившийся держит
  // отдел в $_LHC.attributes и передаёт его в iframe, когда собирает тот;
  // reloadWidget пересобирает iframe. Не документировано — сверено по исходникам
  // LHC 4.93 (design/defaulttheme/widget/wrapper/src). Идущий чат так не переезжает:
  // он продолжается в своём отделе.
  const lhc = window.$_LHC;
  if (lhc && lhc.attributes && lhc.eventListener) {
    lhc.attributes.department = department;
    lhc.eventListener.emitEvent("reloadWidget");
  } else {
    setArgs(department);
  }
};

const applyPath = (pathname) => {
  const seq = ++pathSeq;
  const id = conferenceIdFromPath(pathname);

  if (!id || !lhcDepartmentPrefix) {
    applyDepartment(GENERAL);
    return;
  }

  if (conferenceCache[id]) {
    applyDepartment(conferenceChat(conferenceCache[id], lhcDepartmentPrefix));
    return;
  }

  // На странице конференции скрипт грузится только после ответа: так виджет с первого
  // показа знает свой отдел, и переключение на лету нужно лишь для переходов внутри SPA.
  userService.getWrapper(
    "api/conference/" + id,
    (response) => {
      const conf = response.data;
      conferenceCache[id] = conf;
      if (seq === pathSeq) applyDepartment(conferenceChat(conf, lhcDepartmentPrefix));
    },
    () => {
      if (seq === pathSeq) applyDepartment(GENERAL);
    }
  );
};

// Чат с оператором (Live Helper Chat). Адрес сервера — REACT_APP_LHC_URL, пусто — чата нет.
// Язык фиксируется при загрузке страницы: смену языка без перезагрузки виджет не подхватит.
export const initLhcWidget = () => {
  if (!lhcUrl) return;

  window.LHC_API = window.LHC_API || {};

  syncUserToken();
  applyPath(history.location.pathname);
  history.listen((location) => {
    syncUserToken();
    applyPath(location.pathname);
  });
};
